import Popup from 'src/Components/Popup'
import Input from 'src/Components/Form/Input'
import style from './style.module.scss'
import Select from 'src/Components/Form/Select'
import { IClientCreate } from 'src/utils/Interfaces/client.interface'
import { useState } from 'react'

interface Props {
  handleClientMainInfo: (value: Partial<IClientCreate>) => void
  setClientMainInfoPopup: (value: boolean) => void
  defaultData: IClientCreate
}

type ClientStatus = IClientCreate['status']
const clientStatusOptions: ClientStatus[] = ['ACTIVE', 'INACTIVE', 'PENDING', 'BLOCKED']

export const ClientMainInfoPopup = ({ handleClientMainInfo, setClientMainInfoPopup, defaultData }: Props) => {
  const [name, setName] = useState(defaultData?.name || '')
  const [site, setSite] = useState(defaultData?.siteUrl || '')
  const [status, setStatus] = useState<ClientStatus>(defaultData?.status || 'ACTIVE')
  const [type, setType] = useState(defaultData?.type || '')

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    handleClientMainInfo({
      name,
      siteUrl: site,
      status,
      type
    })
  }
  return (
    <Popup className={style.new_experiment} title="Edit client" closePopup={() => setClientMainInfoPopup(false)}>
      <form onSubmit={handleSubmit}>
        <Input name="name" label="Name" value={name} onChange={(e) => setName(e.target.value)} required />
        <Input name="site" label="Site" value={site} onChange={(e) => setSite(e.target.value)} />
        <Select label="Status" list={clientStatusOptions} value={status} onChange={(value: ClientStatus) => setStatus(value)} />
        <Input name="type" label="Type" value={type} onChange={(e) => setType(e.target.value)} />
        <button className="btn" type="submit">
          Add
        </button>
      </form>
    </Popup>
  )
}
